/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const ShovelBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m20.138 4.359-.707-.707a3.75 3.75 0 0 0-5.303 0l-3.89 3.889a1.25 1.25 0 0 0 0 1.768l1.6 1.6-9.03 9.031c-.18.179-.166.482.03.677l.707.707c.195.195.498.209.677.03l9.031-9.031 1.228 1.228a1.25 1.25 0 0 0 1.768 0l3.889-3.889a3.75 3.75 0 0 0 0-5.303Zm-5.843 6.885 1.07 1.07L19.077 8.6a2.25 2.25 0 0 0 0-3.182l-.707-.707a2.25 2.25 0 0 0-3.182 0l-3.712 3.713 1.523 1.523 1.7-1.29c.258-.196.587-.2.777-.01l.119.119c.19.19.185.518-.01.777l-1.29 1.7Z" /></svg>);
const Shovel = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={ShovelBase} {...rest} ref={ref} />);
export default Shovel;